// Why a prospect is deleted (locales: recordForm.deleteReason_*). « other »
// asks for details: the reason must say something.
export const COMPANY_DELETE_REASONS = [
  'duplicate',
  'test',
  'spam',
  'outOfScope',
  'other',
];
